import {
  Alert,
  Button,
  Modal,
  ModalBody
} from 'reactstrap'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import ConsignmentInboundRequestAddressCardRadio from '../address-card-radio'

const propTypes = {
  toggle              : PropTypes.func,
  isModalOpen         : PropTypes.bool,
  userId              : PropTypes.number,
  addresses           : PropTypes.arrayOf(PropTypes.object),
  selectedAddress     : PropTypes.object,
  handleSelectAddress : PropTypes.func,
  pageUtils           : PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  toggle              : () => {},
  isModalOpen         : () => {},
  userId              : '',
  addresses           : [],
  selectedAddress     : {},
  handleSelectAddress : () => {}
}

const ConsignmentInboundRequestAddressModal = ({
  toggle,
  isModalOpen,
  userId,
  selectedAddress,
  addresses,
  handleSelectAddress
}) => {
  const history = useHistory()

  const handleClickEditAddress = (address) => {
    history.push({
      pathname : `/app/user-address/${address.id}/edit`,
      state    : { address: address }
    })
  }

  const handleClickNewAddress = () => {
    history.push({ pathname: `/app/users/${userId}/addresses/create` })
  }

  const Header = () => (
    <div className='d-flex align-items-center mb-4'>
      <i className='fas fa-chevron-left'
        onClick={ () => toggle() }
      />
    </div>
  )

  return (
    <Modal
      scrollable
      centered
      isOpen={ isModalOpen }
      toggle={ () => toggle(!isModalOpen) }
      className='mx-auto my-auto'
      size={ 'lg' }
    >
      <ModalBody >

        <Header />
        <div className='d-flex align-items-center justify-content-between mb-3'>
          <h4 className='my-0'>Addresses</h4>
          <Button
            size='sm'
            color='success'
            onClick={ handleClickNewAddress }
          >
            { 'Create Address' }
          </Button>
        </div>
        {
          addresses.length === 0 && (
            <Alert color='info'>
              <i className='fas fa-info-circle mr-2' />
              You have no addresses saved.
            </Alert>
          ) }
        {
          addresses.map((address) => (
            <ConsignmentInboundRequestAddressCardRadio
              key={ `seller-inbound-address-card-radio-${address.id}` }
              address={ address }
              isSelected={ selectedAddress?.id == address.id }
              handleClickEdit={ handleClickEditAddress }
              handleSelect={ handleSelectAddress }
            />
          ))
        }
      </ModalBody>
    </Modal>
  )
}

ConsignmentInboundRequestAddressModal.propTypes    = propTypes
ConsignmentInboundRequestAddressModal.defaultProps = defaultProps

export default ConsignmentInboundRequestAddressModal
